<template>
  <div id="publicService" class="page-wrap">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>通知公众号</el-breadcrumb-item>
        <el-breadcrumb-item>公众号用户</el-breadcrumb-item>
      </el-breadcrumb>
    <div class="page">
      <el-row>
        <el-col :span="12">
          <el-button type="primary" icon="el-icon-plus" @click="newAdd" size="small">新增客服</el-button>
        </el-col>
        <el-col :span="12">
          <div style="float: right;position: relative;">
            <el-input v-model="name" placeholder="请输入客服姓名" style="width: 240px;position: relative;" size="small"></el-input>
            <el-button icon="el-icon-search" type="text" style="position: absolute;left: 216px;top: -3px;" @click="oneStep(1)"></el-button>
          </div>
        </el-col>
      </el-row>
      <el-table :data="tableData" style="width: 100%;margin-top: 5px;">
        <el-table-column label="序号" width="120">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="serviceName" label="客服姓名">
        </el-table-column>
        <el-table-column prop="nickName" label="聊天昵称">
        </el-table-column>
        <el-table-column prop="roleName" label="沟通角色">
        </el-table-column>
        <el-table-column prop="groupName" label="所在服务小组">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="theEditor(scope.row)" style="font-size: 14px;">
              <i class="el-icon-edit-outline"></i>
              编辑
            </el-button>
            <span class="positionIcon">|</span>
            <el-button size="small" type="text" @click="deletService(scope.row.id)" style="font-size: 14px;">
              <i class="el-icon-delete"></i>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="this.tableData.length > 0">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 30, 40]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
      <!-- 新增限价弹框 -->
      <div id="dialog">
        <el-dialog :title="newTitle" :visible.sync="newAddShow" width="20%" style="margin-top: 7%;">
          <div style="text-align: center;">
            <el-form :model="form" :rules="rules" ref="ruleForm">
              <el-form-item label="客服姓名" :label-width="formLabelWidth"  prop="serviceid">
                <el-select size="small" clearable filterable v-model="form.serviceid" placeholder="全部" style="width: 100%;" @change="assignment">
                  <el-option
                    v-for="item in serviceNameData"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                    :disabled="item.status == 0"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="聊天昵称" :label-width="formLabelWidth"  prop="nickName">
                <el-input placeholder="请输入内容" v-model="form.nickName" clearable  size="small" style="width: 100%;">
                </el-input>
              </el-form-item>
              <el-form-item label="沟通角色" :label-width="formLabelWidth" prop="roleName">
                <el-select size="small" clearable v-model="form.roleName" placeholder="全部" style="width: 100%;">
                  <el-option
                    v-for="item in roleData"
                    :key="item"
                    :value="item"
                    :label="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('ruleForm')" size="small">确 定</el-button>
            <el-button @click="newAddShow = false" size="small" style="margin-left: 10px;" type="TheCustom">取 消</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- 新增限价弹框 -->
      <el-dialog
        title="删除" id="dialog"
        :visible.sync="deleteShow"
        width="20%" style="margin-top: 10%;">
        <div style="display: flex;width: 100%;justify-content:center;">
            <i class="el-icon-warning" style="color:#faad14;font-size: 35px;margin-top: -5px;"></i>
           <!-- <div> -->
            <div style="font-size: 16px;">你确认要删除吗？</div>
           <!-- </div> -->
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="sureDelete" size="small" >确 定</el-button>
          <el-button @click="deleteShow = false" size="small" type="TheCustom" style="margin-left: 10px;">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import pagination from "../../components/dataTable/pagination";
  export default {
    data() {
      return {
        name: '',
        newTitle: '新增',
        tableData: [{
          realname: '来啊！快活啊！'
        }],
        pageNo: 1,
        pageSize: 10,
        currentPage: 1,
        title: '',
        serviceNameData: [],
        roleData: [],
        totalNum: 10,
        type: '',
        newAddShow: false,
        deleteShow: false,
        formLabelWidth: '80px',
        rules: {
          roleName: [
            { required: true, message: '请选择沟通角色', trigger: 'blur' },
          ],
          nickName: [
            { required: true, message: '请输入聊天昵称', trigger: 'blur' },
          ],
          serviceid: [
            { required: true, message: '请选择客户姓名', trigger: 'blur' },
          ],
        },// 新增必填项
        form: {
          roleName: '',
          nickName: '',
          serviceid: '',
        },// 新增必填项
        serviceName: '',
        groupid: '',
        groupName: '',
        deleteId: '',
        editorId: '',
      }
    },
    mounted() {
      this.oneStep()
    },
    methods: {
      sureDelete() {
        let params={
          id: this.deleteId,
        }
        fetch({
          url: "hcm/wechat/deleteService",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.deleteShow = false
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.oneStep()
          } else {
            this.$message.error(res.message);
          }
        })
      },
      assignment() {
        console.log(this.form.serviceid)
        for (var i = 0; i < this.serviceNameData.length; i++) {
          if (this.form.serviceid ===  this.serviceNameData[i].id) {
            if (this.serviceNameData[i].realname) {
              this.serviceName = this.serviceNameData[i].realname
            } else {
              this.serviceName = ''
            }
            if (this.serviceNameData[i].depart_name) {
              this.groupName = this.serviceNameData[i].depart_name
            } else {
              this.groupName = ''
            }
            if (this.serviceNameData[i].departid) {
              this.groupid = this.serviceNameData[i].departid
            } else {
              this.groupid = ''
            }
          }
        }
      },
      submitForm(formName) {
        var that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params={
              serviceName: this.serviceName,
              serviceid: this.form.serviceid,
              nickName: this.form.nickName,
              roleName: this.form.roleName,
              groupid: this.groupid,
              groupName: this.groupName,
            }
            if (this.newTitle == '新增') {
              fetch({
                url: "hcm/wechat/increaseService",
                method: "get",
                params: params,
                noFormat: true,
                responseType: "text"
              }).then(result => {
                let res = JSON.parse(result);
                let {data}=res
                if(res.status == '10000'){
                  this.newAddShow = false
                  this.$message({
                    message: '新增成功',
                    type: 'success'
                  });
                  this.oneStep()
                } else {
                  this.$message.error(res.message);
                }
              })
            } else {
              if (this.editorId) {
                params.id = this.editorId
              }
              fetch({
                url: "hcm/wechat/updateService",
                method: "get",
                params: params,
                noFormat: true,
                responseType: "text"
              }).then(result => {
                let res = JSON.parse(result);
                let {data}=res
                if(res.status == '10000'){
                  this.newAddShow = false
                  this.$message({
                    message: '新增成功',
                    type: 'success'
                  });
                  this.oneStep()
                } else {
                  this.$message.error(res.message);
                }
              })
            }
          }
        })
      },
      // 编辑
      theEditor(e) {
        console.log(e)
        this.form.serviceid = parseInt(e.serviceid)
        this.form.nickName = e.nickName
        this.form.roleName = e.roleName
        this.serviceName = e.serviceName
        this.groupid = e.groupid
        this.groupName = e.groupName
        this.editorId = e.id
        this.newAddShow = true
        this.newTitle = '编辑'
        this.getSysUserIn()
        this.getConnectRole()
      },
      // 客服姓名
      getSysUserIn() {
        fetch({
          url: "hcm/wechat/getSysUserIn",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.serviceNameData = res.data
          }
        })
      },
      // 沟通角色
      getConnectRole() {
        fetch({
          url: "hcm/wechat/getConnectRole",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.roleData = res.data
          }
        })
      },
      // 新增
      newAdd() {
        this.newAddShow = true
        this.newTitle = '新增'
        this.form.serviceid = ''
        this.form.nickName = ''
        this.form.roleName = ''
        this.serviceName = ''
        this.groupid = ''
        this.groupName = ''
        this.getSysUserIn()
        this.getConnectRole()
      },
      deletService(id) {
        this.deleteShow = true
        this.deleteId = id
      },
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.oneStep();
      },
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.oneStep();
      },
      oneStep(e) {
        if (e == 1) {
          this.pageNo = 1
          this.currentPage = 0
        }
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
        if (this.name) {
          params.name = this.name;
        }
        fetch({
          url: "hcm/wechat/selectService",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.currentPage = 1
            this.tableData = data.content
            this.totalNum = data.totalElements
          }
        })
      },

    },
    components: {
      pagination
    }
  }
</script>
<style lang="scss">
#publicService {
  #dialog {
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
  }
  .page {
    margin: 20px;
    background-color: white;
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #d9d9d9;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
  .el-button+.el-button {
    margin-left: 0px;
  }
  .bottom_page .el-pagination {
    text-align: right;
    margin-top: 0px;
    padding-bottom: 0px;
  }
  .positionIcon {
    color: #d9d9d9;
    padding-left: 7px;
    padding-right: 7px;
    font-weight: 200;
  }
}
</style>
